/* Menu accessibility only. Native Impact owns cart, quantities, gallery and localization submissions. */
(() => {
  if (window.__ploumiBG3) return;
  window.__ploumiBG3 = true;
  function closeMenus(target, restore) {
    document.querySelectorAll('[data-bg3-menu][open]').forEach(menu => {
      if (target && menu.contains(target) && !target.closest('a')) return;
      menu.open = false;
      if (restore) menu.querySelector('summary')?.focus();
    });
  }
  document.addEventListener('click', event => {
    if (event.target instanceof Element) closeMenus(event.target, false);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeMenus(null, true);
  });
})();
